import { IconProps } from './icons-props';

function HeartIcon({ className, width = 24, height = 24 }: IconProps) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox='0 0 22 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M15.4404 1.11731C18.6415 1.11754 21.2499 3.74094 21.25 6.95715C21.25 10.2415 19.8024 13.0069 17.8682 15.1241C15.9295 17.2461 13.5284 18.6869 11.6982 19.3146L11.6904 19.3165C11.5108 19.3812 11.2721 19.4171 11 19.4171C10.7279 19.4171 10.4892 19.3812 10.3096 19.3165L10.3018 19.3146L9.95215 19.1876C8.17344 18.5042 5.94953 17.111 4.13184 15.1202C2.19736 13.0015 0.75 10.2363 0.75 6.95715C0.750084 3.73145 3.35802 1.11754 6.55957 1.11731C8.11709 1.11731 9.56904 1.72503 10.6445 2.80969L11 3.16711L11.3555 2.80969C12.431 1.72503 13.8829 1.11731 15.4404 1.11731ZM15.4502 1.61731C13.7713 1.61731 12.2121 2.40277 11.208 3.75989L11.207 3.76086C11.1776 3.80059 11.1105 3.84192 11.0098 3.84192C10.909 3.84185 10.8418 3.80062 10.8125 3.76086L10.8096 3.75696C9.78616 2.39269 8.23847 1.61731 6.55957 1.61731C3.63098 1.61754 1.25008 4.01393 1.25 6.95715C1.25 10.5459 2.979 13.3241 4.97266 15.2882C6.96001 17.246 9.24551 18.4326 10.4678 18.8507L10.4717 18.8517C10.6377 18.907 10.8436 18.922 11.0049 18.922C11.1661 18.922 11.3721 18.907 11.5381 18.8517L11.542 18.8497C12.7584 18.4319 15.0443 17.2489 17.0332 15.2921C19.0282 13.3293 20.7598 10.5511 20.7598 6.95715C20.7597 4.01385 18.3789 1.61742 15.4502 1.61731Z'
                fill='currentColor'
                stroke='currentColor'
            />
        </svg>
    );
}

export default HeartIcon;

